(() => {
  if (window.nhCartDelivery) return;
  window.nhCartDelivery = true;
  let result = null;
  let revision = 0;
  let timer;
  let controller;
  const mount = () => {
    const root = document.getElementById('slidecarthq');
    const label = root?.querySelector('.footer .shipping-label');
    const value = root?.querySelector('.footer .shipping-cost');
    if (!label || !value) return;
    if (!result) {
      if (value.textContent !== '…') value.textContent = '…';
      return;
    }
    const nextLabel = result.querySelector('[data-nh-delivery-label]')?.textContent.trim();
    const nextValue = result.querySelector('[data-nh-delivery-value]')?.textContent.trim();
    if (nextLabel && label.textContent !== nextLabel) label.textContent = nextLabel;
    if (nextValue && value.textContent !== nextValue) value.textContent = nextValue;
  };
  const refresh = () => {
    const current = ++revision;
    controller?.abort();
    result = null;
    mount();
    clearTimeout(timer);
    timer = setTimeout(async () => {
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const config = JSON.parse(document.getElementById('nh-cart-config')?.textContent || '{}');
        const url = new URL(config.cartUrl || '/cart', location.origin);
        url.searchParams.set('section_id', 'nh-cart-delivery');
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:controller.signal});
        if (!response.ok) throw new Error('delivery');
        const html = await response.text();
        if (current !== revision) return;
        result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nh-cart-delivery-result]');
        if (!result) throw new Error('delivery');
        document.querySelectorAll('[data-nh-native-delivery]').forEach(node => node.replaceChildren(result.cloneNode(true)));
        mount();
      } catch (error) {
        if (current !== revision) return;
        result = document.createElement('div');
        const value = document.createElement('span');
        value.dataset.nhDeliveryValue = '';
        const language = document.documentElement.lang.split('-')[0];
        value.textContent = ({it:'Da verificare con indirizzo',en:'Confirm with delivery address',es:'Por confirmar con la dirección',fr:'À confirmer avec l’adresse',de:'Mit Lieferadresse bestätigen'})[language] || 'Confirm with delivery address';
        result.append(value);
        mount();
      } finally { clearTimeout(timeout); }
    }, 120);
  };
  ['SLIDECART_LOADED','SLIDECART_UPDATED','SLIDECART_OPENED'].forEach(name => {
    const previous = window[name];
    window[name] = function(...args) {
      try { return typeof previous === 'function' ? previous.apply(this,args) : undefined; }
      finally { refresh(); }
    };
  });
  document.addEventListener('cart-updated',refresh,true);
  const start = () => {
    new MutationObserver(mount).observe(document.body,{childList:true,subtree:true,characterData:true});
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
